export default {
  name: 'PopupDateTimeCpt',
  data() {
    return {
      show: false,
      currentDate: [],
      currentTime: []
    };
  },
  computed: {
    minDate() {
      const today = new Date();
      return new Date(today.getFullYear() - 100, 1, 1);
    },
    maxDate() {
      const today = new Date();
      return new Date(today.getFullYear() + 100, today.getMonth() + 1, today.getDate());
    }
  },
  mounted() {
    const today = new Date();
    let year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();
    if (month.length == 1) {
      month = `0${month}`;
    }
    let day = today.getDate().toString();
    if (day.length == 1) {
      day = `0${day}`;
    }
    let hour = today.getHours().toString();
    if (hour.length == 1) {
      hour = `0${hour}`;
    }
    let minute = today.getMinutes().toString();
    if (minute.length == 1) {
      minute = `0${minute}`;
    }
    this.currentDate = [year, month, day];
    this.currentTime = [hour, minute];
  },
  methods: {
    showView() {
      this.show = true;
    },
    onConfirm() {
      const time = this.currentDate.join('-') + ' ' + this.currentTime.join(":") + ":00";
      this.$emit('onSelectedChange', time);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    }
  }
};